/* IWI Trade Tools — interactive sub-region maps (/pages/trade-maps).
   Each zone section (sections/iwi-tt-map-*.liquid) carries an inline SVG (relief, contours, OSM layers, pins)
   and two JSON blocks: data-ttm-pins (sourced positions, DEM figures, vineyard facts) and data-ttm-producers
   (Liquid: producer metaobject + wines). This file adds tabs, pan/zoom, layers, pins, panel and print. */
(function () {
  'use strict';
  if (window.IWITTM) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ASP = { N: 'north', NE: 'north-east', E: 'east', SE: 'south-east', S: 'south', SW: 'south-west', W: 'west', NW: 'north-west' };
  var json = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  var host = function (u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return 'source'; } };

  function Zone(sec) {
    this.sec = sec; this.id = sec.getAttribute('data-ttm');
    this.W = +sec.dataset.w; this.H = +sec.dataset.h; this.km = +sec.dataset.km;
    this.svg = $('[data-ttm-svg]', sec); this.vp = $('[data-ttm-viewport]', sec);
    this.panel = $('[data-ttm-panel]', sec); this.tip = $('[data-ttm-tip]', sec); this.map = $('[data-ttm-map]', sec);
    var pins = json($('[data-ttm-pins]', sec)) || [], prods = json($('[data-ttm-producers]', sec)) || [];
    var by = {}; prods.forEach(function (p) { by[p.h] = p; });
    this.items = pins.map(function (p) { var m = by[p.h] || {}; for (var k in m) if (!(k in p)) p[k] = m[k]; p.name = m.name || p.h; return p; });
    this.vb = { x: 0, y: 0, w: this.W, h: this.H };
    this.sec.style.setProperty('--ttm-ar', this.W / this.H);
    this.init();
  }
  Zone.prototype.init = function () {
    var z = this;
    this.pins = $$('.ttm-pin', this.svg);
    this.fit(); this.apply(); this.fitted = !!this.vp.getBoundingClientRect().width;
    this.bindPanZoom(); this.bindLayers(); this.bindPins();
    this.list();
    $('[data-ttm-print]', this.sec).addEventListener('click', function () { z.print(); });
    window.addEventListener('resize', function () { z.apply(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { z.apply(); }).observe(this.vp);
  };
  /* -------- view box */
  Zone.prototype.full = function () { return { x: 0, y: 0, w: this.W, h: this.H }; };
  Zone.prototype.home = function () { // fill a tall (mobile) viewport around the pins instead of letterboxing
    var r = this.vp.getBoundingClientRect(), b = this.full(); if (!r.width || !r.height) return b;
    var ar = r.width / r.height, mar = this.W / this.H; if (ar >= mar * 0.9) return b;
    var xs = this.pins.map(function (p) { return +p.dataset.x; }), ys = this.pins.map(function (p) { return +p.dataset.y; });
    if (!xs.length) { xs = [this.W / 2]; ys = [this.H / 2]; }
    var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs), y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
    var w = Math.min(this.W, Math.max(this.H * ar, (x1 - x0) * 1.3)), h = Math.min(this.H, w / ar);
    return { x: Math.min(Math.max((x0 + x1) / 2 - w / 2, 0), this.W - w), y: Math.min(Math.max((y0 + y1) / 2 - h / 2, 0), this.H - h), w: w, h: h };
  };
  Zone.prototype.fit = function () { this.vb = this.home(); };
  Zone.prototype.k = function () { return this.W / this.vb.w; };
  Zone.prototype.upp = function () { // user units per screen px (meet)
    var r = this.vp.getBoundingClientRect(); if (!r.width) return 1;
    return Math.max(this.vb.w / r.width, this.vb.h / r.height);
  };
  Zone.prototype.clamp = function () {
    var v = this.vb, minW = this.W / 12;
    if (v.w > this.W) { v.w = this.W; v.h = this.H; }
    if (v.w < minW) { var f = minW / v.w; v.w = minW; v.h *= f; }
    v.x = Math.min(Math.max(v.x, -v.w * 0.25), this.W - v.w * 0.75);
    v.y = Math.min(Math.max(v.y, -v.h * 0.25), this.H - v.h * 0.75);
  };
  Zone.prototype.apply = function () {
    this.clamp(); var v = this.vb;
    this.svg.setAttribute('viewBox', [v.x, v.y, v.w, v.h].map(function (n) { return n.toFixed(1); }).join(' '));
    var u = this.upp(); this.svg.style.setProperty('--ttm-u', u.toFixed(4));
    this.svg.classList.toggle('is-z2', this.k() > 1.7);
    this.svg.classList.toggle('is-far', u > 3.2);
    var s = (30 / 58) * u * 1.25; // pins ~36px tall on screen
    this.pins.forEach(function (p) { p.setAttribute('transform', 'translate(' + p.dataset.x + ' ' + p.dataset.y + ') scale(' + s.toFixed(3) + ')'); });
    // scale bar: pick a round distance ~ 90px
    var kmPerPx = this.km * u, target = kmPerPx * 90, steps = [0.1, 0.2, 0.25, 0.5, 1, 2, 2.5, 5, 10, 20], d = steps[0];
    steps.forEach(function (st) { if (st <= target) d = st; });
    var bar = $('.iwi-ttm__scalebar', this.sec), lbl = $('.iwi-ttm__scalelbl', this.sec);
    if (bar) { bar.style.width = Math.round(d / kmPerPx) + 'px'; lbl.textContent = d < 1 ? (d * 1000) + ' m' : d + ' km'; }
    if (this.tipFor) this.showTip(this.tipFor);
  };
  Zone.prototype.toUser = function (cx, cy) {
    var r = this.vp.getBoundingClientRect(), u = this.upp(), v = this.vb;
    var ox = (r.width * u - v.w) / 2, oy = (r.height * u - v.h) / 2; // meet offsets
    return { x: v.x + (cx - r.left) * u - ox, y: v.y + (cy - r.top) * u - oy };
  };
  Zone.prototype.zoomAt = function (f, cx, cy) {
    var r = this.vp.getBoundingClientRect();
    if (cx == null) { cx = r.left + r.width / 2; cy = r.top + r.height / 2; }
    var p = this.toUser(cx, cy), v = this.vb, nw = Math.min(this.W, Math.max(this.W / 12, v.w / f)), g = nw / v.w;
    v.x = p.x - (p.x - v.x) * g; v.y = p.y - (p.y - v.y) * g; v.w = nw; v.h = v.h * g;
    this.apply();
  };
  Zone.prototype.animateTo = function (t) {
    var z = this, a = Object.assign({}, this.vb), t0 = performance.now(), D = 420;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.vb = t; this.apply(); return; }
    (function step(now) { var q = Math.min(1, (now - t0) / D), e = 1 - Math.pow(1 - q, 3);
      z.vb = { x: a.x + (t.x - a.x) * e, y: a.y + (t.y - a.y) * e, w: a.w + (t.w - a.w) * e, h: a.h + (t.h - a.h) * e }; z.apply();
      if (q < 1) requestAnimationFrame(step); })(t0);
  };
  Zone.prototype.focusPin = function (it) {
    var w = Math.max(this.W / 4.5, Math.min(this.vb.w, this.W / 3)), h = w * this.H / this.W;
    var p = this.pins.filter(function (g) { return g.dataset.h === it.h; })[0]; if (!p) return;
    this.animateTo({ x: +p.dataset.x - w / 2, y: +p.dataset.y - h / 2, w: w, h: h });
  };
  Zone.prototype.bindPanZoom = function () {
    var z = this, vp = this.vp, pts = {}, last = null, dist0 = 0, moved = 0;
    vp.addEventListener('wheel', function (e) { e.preventDefault(); z.zoomAt(Math.exp(-e.deltaY * (e.deltaMode ? 0.05 : 0.0018)), e.clientX, e.clientY); }, { passive: false });
    vp.addEventListener('pointerdown', function (e) {
      if (e.button) return; pts[e.pointerId] = { x: e.clientX, y: e.clientY }; moved = 0;
      if (!e.target.closest('.ttm-pin')) vp.setPointerCapture(e.pointerId);
      var ids = Object.keys(pts); if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]]; dist0 = Math.hypot(a.x - b.x, a.y - b.y); }
      last = { x: e.clientX, y: e.clientY };
    });
    vp.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      var ids = Object.keys(pts); pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
        if (dist0) z.zoomAt(d / dist0, (a.x + b.x) / 2, (a.y + b.y) / 2); dist0 = d; moved += 10; return;
      }
      var u = z.upp(), dx = e.clientX - last.x, dy = e.clientY - last.y; moved += Math.abs(dx) + Math.abs(dy);
      if (moved > 3) vp.classList.add('is-drag');
      z.vb.x -= dx * u; z.vb.y -= dy * u; last = { x: e.clientX, y: e.clientY }; z.apply();
    });
    var end = function (e) { delete pts[e.pointerId]; vp.classList.remove('is-drag'); dist0 = 0; var ids = Object.keys(pts); if (ids.length) last = pts[ids[0]]; };
    vp.addEventListener('pointerup', end); vp.addEventListener('pointercancel', end);
    vp.addEventListener('dblclick', function (e) { if (!e.target.closest('.ttm-pin')) z.zoomAt(1.8, e.clientX, e.clientY); });
    vp.addEventListener('keydown', function (e) {
      var s = z.vb.w * 0.12, k = e.key;
      if (k === '+' || k === '=') z.zoomAt(1.4); else if (k === '-' || k === '_') z.zoomAt(1 / 1.4);
      else if (k === 'ArrowLeft') { z.vb.x -= s; z.apply(); } else if (k === 'ArrowRight') { z.vb.x += s; z.apply(); }
      else if (k === 'ArrowUp') { z.vb.y -= s; z.apply(); } else if (k === 'ArrowDown') { z.vb.y += s; z.apply(); }
      else if (k === '0') { z.animateTo(z.home()); } else return;
      e.preventDefault();
    });
    $$('[data-ttm-zoom]', this.sec).forEach(function (b) {
      b.addEventListener('click', function () { var m = b.dataset.ttmZoom; if (m === 'in') z.zoomAt(1.5); else if (m === 'out') z.zoomAt(1 / 1.5); else z.animateTo(z.home()); });
    });
    this.wasDrag = function () { return moved > 6; };
  };
  Zone.prototype.bindLayers = function () {
    var z = this, svg = this.svg;
    $$('[data-layer]', this.sec).forEach(function (cb) {
      var set = function () {
        var l = cb.dataset.layer, on = cb.checked;
        if (l === 'aspect') {
          var im = $('.ttm-asp image', svg);
          if (on && im && !im.getAttribute('href')) im.setAttribute('href', im.getAttribute('data-href'));
          svg.classList.toggle('has-aspect', on); z.map.classList.toggle('has-aspect', on);
        } else svg.classList.toggle('no-' + l, !on);
      };
      cb.addEventListener('change', set); set();
    });
  };
  /* -------- pins, tooltip, panel */
  Zone.prototype.item = function (h) { return this.items.filter(function (i) { return i.h === h; })[0]; };
  Zone.prototype.showTip = function (g) {
    var it = this.item(g.dataset.h); if (!it) return;
    var r = g.getBoundingClientRect(), m = this.map.getBoundingClientRect();
    this.tip.innerHTML = '<b>' + esc(it.n + '. ' + it.name) + '</b><span>' + esc(it.town || '') + (it.dem ? ' · cellar ≈ ' + it.dem.ele + ' m' : '') + '</span>';
    this.tip.style.left = (r.left + r.width / 2 - m.left) + 'px'; this.tip.style.top = (r.top - m.top) + 'px';
    this.tip.hidden = false; this.tipFor = g;
  };
  Zone.prototype.hideTip = function () { this.tip.hidden = true; this.tipFor = null; };
  Zone.prototype.bindPins = function () {
    var z = this;
    this.pins.forEach(function (g) {
      g.addEventListener('pointerenter', function () { z.showTip(g); });
      g.addEventListener('pointerleave', function () { z.hideTip(); });
      g.addEventListener('focus', function () { z.showTip(g); });
      g.addEventListener('blur', function () { z.hideTip(); });
      g.addEventListener('click', function (e) { e.stopPropagation(); if (z.wasDrag()) return; z.open(g.dataset.h); });
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); z.open(g.dataset.h); } });
    });
  };
  Zone.prototype.list = function () {
    var z = this;
    this.pins.forEach(function (p) { p.classList.remove('is-on'); });
    var h = '<div class="ttm-plist__h">' + this.items.length + ' producers on this map</div><ul class="ttm-plist" role="list">';
    this.items.forEach(function (it) {
      h += '<li><button type="button" data-open="' + esc(it.h) + '"><span class="ttm-num">' + it.n + '</span><span><span class="ttm-plist__n">' + esc(it.name) + '</span><span class="ttm-plist__s">' + esc(it.town || '') + '</span></span><span class="ttm-plist__e">' + (it.dem ? it.dem.ele + ' m' : '') + '<span class="ttm-plist__s">' + (it.wines ? it.wines.length + ' wines' : '') + '</span></span></button></li>';
    });
    h += '</ul><p class="ttm-note" style="padding:0 16px 16px">Elevation shown is the cellar site, read from the elevation model. Vineyard altitudes and aspects are in each producer’s panel, quoted from the producer.</p>';
    this.panel.innerHTML = h;
    $$('[data-open]', this.panel).forEach(function (b) {
      b.addEventListener('click', function () { z.open(b.dataset.open); });
      b.addEventListener('mouseenter', function () { var g = z.pins.filter(function (p) { return p.dataset.h === b.dataset.open; })[0]; if (g) g.classList.add('is-on'); });
      b.addEventListener('mouseleave', function () { z.pins.forEach(function (p) { p.classList.remove('is-on'); }); });
    });
    this.printList();
  };
  Zone.prototype.open = function (h) {
    var z = this, it = this.item(h); if (!it) return;
    this.pins.forEach(function (p) { p.classList.toggle('is-on', p.dataset.h === h); });
    this.focusPin(it);
    var d = it.dem, posTxt = it.pos === 'exact' ? 'Pin from the map the producer links to on its own website.' : it.pos === 'osm' ? 'Pin from the OpenStreetMap feature at the address published by the producer.' : 'Pin from the Google Maps listing for the address published by the producer.';
    var html = '<article class="ttm-pd"><div class="ttm-pd__hero"' + (it.hero ? ' style="background-image:url(' + esc(it.hero) + ')"' : '') + '><button type="button" class="ttm-pd__back" data-back>← All producers</button>' + (it.logo ? '<span class="ttm-pd__logo"><img src="' + esc(it.logo) + '" alt="" loading="lazy"></span>' : '') + '</div><div class="ttm-pd__body">';
    html += '<h3 class="ttm-pd__name"><span class="ttm-num" style="display:inline-grid;vertical-align:middle;margin-right:8px">' + it.n + '</span>' + esc(it.name) + '</h3><p class="ttm-pd__town">' + esc(it.town || '') + (it.region ? ', ' + esc(it.region) : '') + '</p>';
    html += '<div class="ttm-facts">' + (d ? '<div class="ttm-fact"><b>' + d.ele + ' m</b><span>Cellar site elevation*</span></div><div class="ttm-fact"><b>' + esc(d.asp) + '</b><span>Cellar slope faces ' + esc(ASP[d.asp] || '') + '*</span></div>' : '') + (it.ha ? '<div class="ttm-fact"><b>' + esc(String(it.ha).replace(/\s*ha$/, '')) + '</b><span>Hectares</span></div>' : '') + '</div>';
    if (it.vy && it.vy.length) {
      html += '<h4>Vineyards — as stated by the producer</h4><table class="ttm-vy"><thead><tr><th>Site</th><th>Altitude</th><th>Aspect</th><th>ha</th></tr></thead><tbody>';
      it.vy.forEach(function (v) { html += '<tr><td>' + esc(v.n) + (v.note ? '<div class="ttm-note">' + esc(v.note) + '</div>' : '') + (v.src ? '<div><a href="' + esc(v.src) + '" target="_blank" rel="noopener">' + esc(host(v.src)) + ' ↗</a></div>' : '') + '</td><td>' + esc(v.alt || '—') + '</td><td>' + esc(v.asp || '—') + '</td><td>' + esc(v.ha || '—') + '</td></tr>'; });
      html += '</tbody></table>';
    } else html += '<h4>Vineyards</h4><p class="ttm-note">The producer’s website does not publish vineyard altitudes or aspects, so none are shown.</p>';
    html += '<p class="ttm-note">' + esc(it.addr) + '. ' + posTxt + ' <a href="' + esc(it.addr_src) + '" target="_blank" rel="noopener">Address source ↗</a><br>* Calculated from the elevation model at the cellar pin, not stated by the producer.' + (d ? ' Slope there ≈ ' + d.slope + '°.' : '') + '</p>';
    if (it.wines && it.wines.length) {
      html += '<h4>Our wines (' + it.wines.length + ')</h4><ul class="ttm-wines" role="list">';
      it.wines.forEach(function (w) { html += '<li class="ttm-wine">' + (w.img ? '<img src="' + esc(w.img) + '" alt="" loading="lazy" width="40" height="56">' : '<span></span>') + '<div><a class="ttm-wine__t" href="' + esc(w.u) + '">' + esc(w.t) + '</a><div class="ttm-wine__a"><a href="' + esc(w.u) + '?view=sheet" target="_blank" rel="noopener">Tech sheet</a><a href="' + esc(w.u) + '?view=talker" target="_blank" rel="noopener">Shelf talker</a></div></div></li>'; });
      html += '</ul>';
    }
    html += '<div class="ttm-links">' + (it.url ? '<a class="is-primary" href="' + esc(it.url) + '">In cantina →</a>' : '') + '<a href="/pages/trade-media?producer=' + encodeURIComponent(it.h) + '">Producer kit</a>' + (it.web ? '<a href="' + esc(it.web) + '" target="_blank" rel="noopener">Website ↗</a>' : '') + '</div>';
    html += '</div></article>';
    this.panel.innerHTML = html; this.panel.scrollTop = 0;
    $('[data-back]', this.panel).addEventListener('click', function () { z.list(); z.animateTo(z.home()); });
    if (window.innerWidth < 990) this.panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try { var u = new URL(location.href); u.searchParams.set('zone', this.id); u.searchParams.set('producer', h); history.replaceState(null, '', u); } catch (e) {}
  };
  Zone.prototype.printList = function () {
    var box = $('[data-ttm-printlist]', this.sec); if (!box) return;
    var h = '<table class="ttm-ptable"><thead><tr><th>#</th><th>Producer</th><th>Cellar (elev. model)</th><th>Vineyards as stated by the producer</th><th>Wines</th></tr></thead><tbody>';
    this.items.forEach(function (it) {
      var vy = (it.vy || []).map(function (v) { return esc(v.n) + (v.alt ? ' · ' + esc(v.alt) : '') + (v.asp ? ' · ' + esc(v.asp) : ''); }).join('<br>') || '—';
      h += '<tr><td><span class="ttm-num">' + it.n + '</span></td><td><b>' + esc(it.name) + '</b><br>' + esc(it.addr) + '</td><td>' + (it.dem ? it.dem.ele + ' m, faces ' + esc(it.dem.asp) : '') + '</td><td>' + vy + '</td><td>' + (it.wines || []).map(function (w) { return esc(w.t); }).join('<br>') + '</td></tr>';
    });
    box.innerHTML = h + '</tbody></table>';
  };
  Zone.prototype.print = function () {
    var z = this, sec = this.sec.closest('.iwi-ttm-section') || this.sec;
    var prev = Object.assign({}, this.vb); this.vb = this.full(); this.apply(); this.hideTip();
    document.body.classList.add('ttm-printing'); sec.classList.add('is-printing');
    var done = function () { document.body.classList.remove('ttm-printing'); sec.classList.remove('is-printing'); z.vb = prev; z.apply(); window.removeEventListener('afterprint', done); };
    window.addEventListener('afterprint', done);
    setTimeout(function () { window.print(); }, 60);
  };

  /* -------- tabs (index section) + deep links */
  var zones = {};
  function show(id, focus) {
    var secs = $$('section[data-ttm]'); if (!secs.length) return;
    if (!id || !$('section[data-ttm="' + id + '"]')) id = secs[0].getAttribute('data-ttm');
    secs.forEach(function (s) { var on = s.getAttribute('data-ttm') === id; var w = s.closest('.iwi-ttm-section') || s; w.hidden = !on; s.hidden = !on; });
    $$('[data-ttm-tab]').forEach(function (t) { var on = t.dataset.ttmTab === id; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
    var sec = $('section[data-ttm="' + id + '"]');
    if (!zones[id]) zones[id] = new Zone(sec); else { if (!zones[id].fitted) { zones[id].fit(); zones[id].fitted = true; } zones[id].apply(); }
    if (focus) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return zones[id];
  }
  function boot() {
    var tabs = $$('[data-ttm-tab]');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.dataset.ttmTab, true); try { var u = new URL(location.href); u.searchParams.set('zone', t.dataset.ttmTab); u.searchParams.delete('producer'); history.replaceState(null, '', u); } catch (e) {} });
      t.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); n.click(); });
    });
    var q = new URLSearchParams(location.search), id = q.get('zone') || (location.hash || '').slice(1);
    var z = show(id, false);
    if (z && q.get('producer')) setTimeout(function () { z.open(q.get('producer')); }, 50);
  }
  window.IWITTM = { show: show, zones: zones };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
